export { default } from "bullitttime-embermodelsgochips/models/passing";
